<template>
  <div id="bar"
       :style="size">
    <e-charts :size="size"
              style="margin-top: -30px;overflow: hidden"
              :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'
// import * as echarts from 'echarts'

export default {
  components: {
    ECharts,
  },
  props: {
    varData: {
      // 物资
      type: Array,
      default: () => ({}),
    },
    weightData: {
      // 净重
      type: Array,
      default: () => ({}),
    },
  },
  created() {},
  data: function () {
    return {
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效，
            type: 'shadow', // 默认为line，line直线，cross十字准星，shadow阴影
          },
          formatter: function (params) {
            // 控制提示格式
            return `${params[0].name}<br/>净重: ${params[0].value} 吨`
          },
        },
        legend: {
          // 图表中对图形的解释部分
          textStyle: {
            // orient: 'vertical',  // 设置图例的朝向  vertical 垂直显示    horizontal 水平显示
            color: 'white',
          },
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine: {
            show: false, // 是否显示x坐标轴轴线
            lineStyle: {
              color: 'white',
            },
          },
        },
        yAxis: {
          type: 'category',
          data: JSON.parse(JSON.stringify(this.varData)),
          axisLine: {
            lineStyle: {
              color: 'white',
            },
          },
          axisLabel: {
            textStyle: {
              color: 'white',
              fontSize: 16,
            },
          },
          axisTick: {
            // y轴刻度线
            show: false, // 是否显示坐标轴刻度
          },
        },
        series: [
          {
            /* itemStyle: {
               normal: {
                 label: {
                   show: true, // 开启显示
                   position: 'right', // 在上方显示
                   textStyle: { // 数值样式
                     color: 'white',
                     fontSize: 12
                   }
                 },

               },
             },*/
            itemStyle: {
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                /*  color: function (params) {
                    const colorList = [
                      "#FF0099",
                      "#8E2DE2",
                      "#14C8D4",
                      "#F87BE2",
                      "#5085F2",
                      "#F2719A",
                      "#1D9394",
                      "#C24545",
                    ];
                    return colorList[params.dataIndex];
                  },*/
                color: function (params) {
                  const colorarrays = [
                    '#FF458C',
                    '#5C7BD9',
                    '#9FE080',
                    '#FFDC60',
                    '#FF7070',
                    '#CB7BF4',
                    '#4B7CF3',
                    '#F24354',
                    '#32D5B9',
                    '#F19E34',
                    '#9565F4',
                    '#0255FD',
                    '#7ED3F4',
                    '#002E5A',
                    '#07D2F9',
                    '#FF0099',
                    '#8E2DE2',
                    '#32D5B9',
                    '#F87BE2',
                    '#40FBCB',
                    '#0780cf',
                    '#CB7BF4',
                    '#f89588',
                    '#63b2ee',
                    '#76da91',
                    '#7cd6cf',
                    '#9192ab',
                    '#7898e1',
                    '#efa666',
                    '#9987ce',
                    '#05f8d6',
                    '#0082fc',
                  ]
                  return colorarrays[params.dataIndex]
                },
              },
            },
            label: {
              show: true, // 开启显示
              position: 'right', // 在上方显示
              textStyle: {
                // 数值样式
                color: 'white',
                fontSize: 14,
              },
            },

            type: 'bar',
            data: JSON.parse(JSON.stringify(this.weightData)),
          },
        ],
      },
      size: {
        width: '95%',
        height: '600px',
      },
    }
  },
  mounted() {},
}
</script>

<style scoped>
</style>
